import React, { useRef, useEffect, useState } from "react";
import Header from "../components/header/header";
import Slider from "react-slick/lib/slider";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../components/datepicker/datepicker.css";
import { SlArrowDown } from "react-icons/sl";
import Books from "../components/books/books";
import Mobileapp from "../components/mobileapp/mobileapp";
import Footer from "../components/footer/footer";
import LatestEvent from "../components/events/latestevent";

var setting = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  cssEase: "linear",
};
const EventPhotos = () => {
  const [lastActiveDarshan, setLastActiveDarshan] = useState({
    fileHdUrls: [],
  });

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const [selectedDate, setSelectedDate] = useState(yesterday);

  const formatDateForApi = (date) => {
    const apiDate = new Date(date);
  
    // reset local date
    apiDate.setHours(0, 0, 0, 0);
  
    // move one day back
    apiDate.setDate(apiDate.getDate() - 1);
  
    // manually build exact backend format
    const year = apiDate.getFullYear();
    const month = String(apiDate.getMonth() + 1).padStart(2, "0");
    const day = String(apiDate.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}T18:30:00.000Z`;
  };

  useEffect(() => {
    const formattedDate = formatDateForApi(selectedDate);
    console.log("API DATE:", formattedDate);

    fetch(
      `https://smvdev.swaminarayansurat.com/admin/daily-darshan?date=${formattedDate}`
    )
      .then((res) => res.json())
      .then((data) => {
        setLastActiveDarshan({
          fileHdUrls: data?.data?.fileHdUrls || [],
        });

        console.log("API RESPONSE DATE:", data?.data?.date);
      })
      .catch((err) => console.error("Error fetching daily darshan:", err));
  }, [selectedDate]);

  const extractFileName = (url) => {
    return url.substring(url.lastIndexOf("/") + 1);
  };

  return (
    <div>
      <div className="header-section pt-40 relative overflow-hidden mb-20">
        <div className="max-w-7xl mx-auto z-10 relative">
          <div className="relative">
            <LatestEvent />
            <img
              src="/assets/hero-shape.svg"
              className="left-shape absolute -left-12 top-20"
              alt="leftshape"
            />
            {/* <img
              src="/assets/hero-shape.svg"
              className="right-shape absolute -right-12 bottom-24"
              alt="rightshape"
            /> */}
          </div>
        </div>
        {/* <img
          src="/assets/left-line.svg"
          className="absolute left-0 top-24"
          alt="leftline"
        /> */}
        <img
          src="/assets/right-line.svg"
          className="absolute right-0 top-24"
          alt="rightline"
        />
      </div>
      {/* Event Photos By Months */}
      <div className="py-20">
        {/* <div className="bg-[#FFF5F3]">
          <img src="./assets/shapeline.png" alt="shape-line" />
        </div> */}
        <div className="max-w-7xl mx-auto px-4">
           
          <div className="flex justify-center items-center gap-3 mb-10">
            <h2
              className="text-5xl text-center"
              style={{ fontFamily: "Philosopher, sans-serif" }}
            >
              {" "}
              Previous <span className="text-primary">
              Events 
              </span>{" "}
            </h2>
            <div className="flex justify-center items-center datepicker">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd-MM-yyyy"
                className="relative z-10 mr-2 w-32 cursor-pointer caret-transparent"
                onKeyDown={(e) => e.preventDefault()}
              />
              <SlArrowDown />
            </div>
          </div>
          <div className="py-3 px-9 mb-8 bg-[#FFE0DC] rounded-[60px] text-[#D8020D] flex justify-between">
                <div>January</div>
                <div>February</div>
                <div>March</div>
                <div>April</div>
                <div>May</div>
                <div>June</div>
                <div>July</div>
                <div>August</div>
                <div>September</div>
                <div>October</div>
                <div>November</div>
                <div>December</div>
            </div>
          <div className="grid grid-cols-4 gap-8">
            {lastActiveDarshan.fileHdUrls?.length > 0 ? (
              lastActiveDarshan.fileHdUrls.map((eachUrl, indx) => {
                return (
                  <div
                    key={`darshan-hd-${indx}-${extractFileName(eachUrl)}`}
                    className="h-full p-2 bg-white"
                  >
                    <div className="w-full rounded-[10px] overflow-hidden h-full relative">
                      <img
                        alt="gallery"
                        className="block h-full w-full rounded-lg object-cover object-center"
                        src={`${eachUrl}`}
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-xs text-[#A4A4A4]">000</div>
            )}
          </div>
        </div>
      </div>
      {/* <div className="py-20 bg-[#FFF5F3] flowers-line"> */}

      <Books />
      {/* </div> */}
      <Mobileapp />
      <Footer />
    </div>
  );
};

export default EventPhotos;
